// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_h2-0";
export var discountCodeInput = "_h2-1";